<template>
  <DelayedTooltip
    v-if="tooltip"
    bottom
  >
    <template #activator="{ on: tooltipOn, attrs: tooltipAttrs }">
      <v-btn
        class="bordered-1 rounded-lg"
        text
        outlined
        small
        :icon="hideLabel === true ? true : $vuetify.breakpoint.smAndDown"
        :color="color"
        style="min-width: 21px"
        v-bind="{ ...tooltipAttrs, ...$attrs }"
        v-on="{ ...tooltipOn, ...$listeners }"
      >
        <v-icon small>
          {{ icon }}
        </v-icon>
        <span
          v-if="label && !(hideLabel === true || $vuetify.breakpoint.smAndDown)"
          class="ml-2"
        >
          <slot name="label">{{ label }}</slot>
        </span>
      </v-btn>
    </template>
    <slot name="tooltip">
      {{ tooltip }}
    </slot>
  </DelayedTooltip>

  <v-btn
    v-else
    class="bordered-1 rounded-lg"
    text
    outlined
    small
    :icon="hideLabel === true ? true : $vuetify.breakpoint.smAndDown"
    :color="color"
    style="min-width: 21px"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <v-icon small>
      {{ icon }}
    </v-icon>
    <span
      v-if="label && !(hideLabel === true || $vuetify.breakpoint.smAndDown)"
      class="ml-2"
    >
      <slot name="label">{{ label }}</slot>
    </span>
  </v-btn>
</template>

<script>
import DelayedTooltip from "@/components/misc/ui/DelayedTooltip.vue";

export default {
  name: "ActionButton",
  components: { DelayedTooltip },
  inheritAttrs: false,
  props: {
    color: {
      type: String,
      default: "review",
    },
    icon: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: null,
    },
    // true = always icon-only; false/undefined = icon-only on smAndDown
    hideLabel: {
      type: Boolean,
      default: undefined,
    },
    // string = show tooltip with that text; falsy = no tooltip
    tooltip: {
      type: String,
      default: null,
    },
  },
};
</script>
